import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EdpCommunicationsConsentsModalModule } from "@edp-components/edp-communications-consents-modal/edp-communications-consents-modal.module";
import { EdpEnvironmentSwitchModalComponent } from "@edp-components/edp-environment-switch-modal/edp-environment-switch-modal.component";
import { ConditionalRegionModule } from "@edp-directives/conditional-region/conditional-region.module";
import { TranslateModule } from "@ngx-translate/core";
import { EdpOverlayUserComponent } from "./edp-overlay-user.component";
import { EdpOverlayCompleteProfileComponent } from "./edp-overlay-complete-profile/edp-overlay-complete-profile.component";
import { EdpProgressBarModule } from "@edp-components/edp-progress-bar/edp-progress-bar.module";
import { GaClickModule } from "@edp-directives/datalayer/gaclick/gaclick.module";

@NgModule({
    declarations: [EdpOverlayUserComponent, EdpEnvironmentSwitchModalComponent, EdpOverlayCompleteProfileComponent],
    imports: [CommonModule, TranslateModule, EdpCommunicationsConsentsModalModule, EdpProgressBarModule, ConditionalRegionModule, GaClickModule],
    exports: [EdpOverlayUserComponent],
    entryComponents: [EdpEnvironmentSwitchModalComponent],
})
export class EdpOverlayUserModule {}
